import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FulfillmentContext } from '../../shipping/fulfillments/context';
import * as GridConfigApi from '../../store/grid-config.api';
import ModalPortal from '../../components/modal-portal';
import { DeleteFilterViewModal } from '../../components/modals/delete-filterview-modal-service';

export const DeleteFulfillmentsFilterViewModalContainer = ({ onClose }) => {
  const { activeFilterViewId, savedFilterViews, deleteFilterView } = useContext(FulfillmentContext);
  const activeFilterView = useMemo(
    () => savedFilterViews.find((view) => view.filterViewId === activeFilterViewId),
    [activeFilterViewId, savedFilterViews],
  );
  const deleteFilterViewRequest = useCallback(
    (filterViewToDelete) => {
      GridConfigApi.deleteFulfillmentsGridConfig(filterViewToDelete).then(() => {
        deleteFilterView(filterViewToDelete);
      });
      onClose();
    },
    [onClose, deleteFilterView],
  );
  return (
    <ModalPortal onClose={onClose}>
      <DeleteFilterViewModal closeModal={onClose} deleteFilterViewRequest={deleteFilterViewRequest} filterViewToDelete={activeFilterView} />
    </ModalPortal>
  );
};

DeleteFulfillmentsFilterViewModalContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
};
